var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_vm._v("\n    Copyright "+_vm._s(new Date().getFullYear())+" "),_c('br'),_vm._v(" Made with 🖤 in Paris, 🇫🇷 🥖 🍷 by "),_c('a',{attrs:{"href":"https://www.blacksmith.studio"}},[_vm._v("Blacksmith")])])}
var staticRenderFns = []

export { render, staticRenderFns }